(function (Drupal, $) {
  Drupal.behaviors.slider = {
    attach: function attach(context) {
      // 50-50 Slider
      if ($(context).find(".fifty-fifty-slider").length) {
        var swiper5050 = new Swiper(".fifty-fifty-slider", {
          effect: 'fade',
          slidesPerView: 1,
          spaceBetween: 30,
          speed: 500,
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          },
          navigation: {
            nextEl: '.fifty-fifty-slider-next',
            prevEl: '.fifty-fifty-slider-prev',
          },
          on: {
            paginationUpdate: function (_swiper, paginationEl) {
              handleAriaForPagination(paginationEl);
            },
            init: function(_swiper) {
              handleAriaForSlides(_swiper);
            },
            slideChange: function(_swiper) {
              handleAriaForSlides(_swiper);
            }
          },
        });
      }

      // Timeline Slider.
      if ($(context).find(".timeline-slider").length) {
        var swiperTl = new Swiper(".timeline-slider", {
          slidesPerView: 1,
          spaceBetween: -1,
          speed: 500,
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
          breakpoints: {
            1199: {
              slidesPerView: 1.75,
            },
          },
          watchSlidesProgress: true,
          on: {
            paginationUpdate: function (_swiper, paginationEl) {
              handleAriaForPagination(paginationEl);
            },
            init: function(_swiper) {
              handleAriaForSlides(_swiper);
            },
            slideChange: function(_swiper) {
              handleAriaForSlides(_swiper);
            }
          },
        });
        var scroll = $('.js--timeline__scroll');
        scroll.click(function(){
          if ($(this).hasClass('play')){
            swiperTl.autoplay.stop();
            $(this).removeClass('play');
          } else {
            swiperTl.slideNext();
            swiperTl.autoplay.start();
            $(this).addClass('play');
          }
        });
      }

      if ($(context).find('.swiper-wrapper').length) {
        var page = $('head title').text();
        $('.swiper-wrapper').removeAttr('aria-live');

        $('.swiper-button-prev').on('click', function (){
          var activeSlide = $('.swiper-slide-active').first();
          var slideLabel = activeSlide.attr('aria-label');
          var slideNum = parseInt(slideLabel.slice(0,1)) + 1;
          var gtmLabel = 'Slide - ' + slideNum;
          var sectionId = $(this).parents('.layout').attr('id');

          swiperGa('carouselClick', `Marketing - ${page} - ${sectionId}`, 'carouselClick', gtmLabel);
        });

        $('.swiper-button-next').on('click', function (){
          var activeSlide = $('.swiper-slide-active').first();
          var slideLabel = activeSlide.attr('aria-label');
          var slideNum = parseInt(slideLabel.slice(0,1)) - 1;
          var gtmLabel = 'Slide - ' + slideNum;
          var sectionId = $(this).parents('.layout').attr('id');

          swiperGa('carouselClick', `Marketing - ${page} - ${sectionId}`, 'carouselClick', gtmLabel);
        });

        $('.swiper-pagination-bullet').on('click', function (){
          var gtmLabel = $(this).attr('aria-label');
          var sectionId = $(this).parents('.layout').attr('id');

          swiperGa('carouselPaginationClick', `Marketing - ${page} - ${sectionId}`, 'carouselPaginationClick', gtmLabel);
        });
      }

      // Make only visible slides not aria-hidden
      // Make all hidden slides' interactive content a negative tab index
      function handleAriaForSlides(_swiper) {
        $(_swiper.$el).find('.swiper-slide').attr('aria-hidden', true);
        $(_swiper.$el).find('.swiper-slide').find('a').attr('tabindex', -1);
        $(_swiper.$el).find('.swiper-slide-visible').attr('aria-hidden', false);
        $(_swiper.$el).find('.swiper-slide-visible').find('a').attr('tabindex', 0);
      }

      function handleAriaForPagination(paginationEl) {
        $(paginationEl).find('.swiper-pagination-bullet').removeAttr('aria-current');
        $(paginationEl).find('.swiper-pagination-bullet-active').attr('aria-current', true);
      }

      function swiperGa(gtmEvent, gtmCategory, gtmAction, gtmLabel) {
        if ( window.dataLayer != undefined ) {
          window.dataLayer.push({
            'event': gtmEvent,
            'category': gtmCategory,
            'action': gtmAction,
            'label': gtmLabel,
          });
        }
      }
    }
  }
})(Drupal, jQuery);
